import Vue from "vue";
import VueLazyload from "vue-lazyload";

import App from "./App.vue";
import mockData from "./mocks/data";
import placeholder from "./assets/placeholder.svg";

if (process.env.NODE_ENV === "production") {
  Vue.prototype.$cchbc =
    (window._cchbc_ && window._cchbc_.appConfiguration) || undefined;
} else {
  Vue.prototype.$cchbc = mockData.appConfiguration;
}

Vue.use(VueLazyload, {
  error: placeholder,
  loading: placeholder,
});

Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App),
}).$mount("#app");
